import { Stack, Typography } from '@mui/material'
import { Lock } from '@mui/icons-material'

export default function LockedMark({ testId }) {
    return (
        <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            data-testid={testId}
            sx={{ marginBottom: 2 }}
        >
            <Lock fontSize="small" color="error" />
            <Typography variant="body2" color="error">נעול לעריכה</Typography>
        </Stack>
    )
}
